import { api_host,api_auth} from '../../common/globals/constants';

export const getValidateMaintenance = (user, token, begin, final, objetivos, nodos) => 
fetch(api_host+`/reporte/online/indicadores/validateMaintenance/?user=${user}&token=${token}&begin=${begin}&final=${final}&objectives=${objetivos}&nodes=${nodos}&timestamp=${new Date().getTime()}`)
.then(response => response.json())